'use client';

import { useBreakpointValue } from '@ironhack/design-system2/hooks';

import { StructuredContent } from '@/app/components/client/structured-content';
import { ModuleWrapper } from '@/app/components/server/module-wrapper';
import { BlogAd } from './blog-ad';
import { type BlogArticleWithAd } from '../../blog-article.queries';

import type { ReactElement } from 'react';

type Props = { data: BlogArticleWithAd };

export const Content = (props: Props): ReactElement => {
  const { data } = props;
  const isMobile = useBreakpointValue({ base: true, lg: false }) ?? true;
  return (
    <>
      <ModuleWrapper
        innerProps={{ direction: ['column', null, 'row'] }}
        moduleFormat={{
          spacingTop: '48',
          spacingBottom: '48',
          background: 'white',
        }}
        outerProps={{ as: 'article' }}
      >
        <StructuredContent data={data.body} ignoreInlineTextStyle />
        {!isMobile && (
          <BlogAd
            as="aside"
            h="max-content"
            ml={8}
            position="sticky"
            top={6}
            {...data.ad}
          />
        )}
      </ModuleWrapper>
      {isMobile && (
        <ModuleWrapper
          innerProps={{ justifyContent: 'center' }}
          moduleFormat={{
            background: 'light',
            spacingTop: '16',
            spacingBottom: '16',
          }}
          outerProps={{ as: 'aside' }}
        >
          <BlogAd alignSelf="center" {...data.ad} />
        </ModuleWrapper>
      )}
    </>
  );
};
